/*
 *
 * LeadsPage
 *
 */

import React from 'react';
import { connect } from 'react-redux';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { mapIsEmpty } from 'utils/helpers';
import { Outlet } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { selectAllLeads } from './selectors';
import { Wrapper } from './styledComponents';
import { fetchLeadsRequest } from './actions';

class LeadsPage extends React.PureComponent {
  render() {
    return (
      <Wrapper>
        <HelmetProvider>
          <Helmet title='Movebooth | Leads' />
        </HelmetProvider>
        <div className='leads-page__content'>
          <Outlet />
        </div>
      </Wrapper>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  leads: selectAllLeads(),
});

const mapDispatchToProps = (dispatch) => ({
  fetchLeads: () => dispatch(fetchLeadsRequest()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LeadsPage);
